import { Injectable } from '@angular/core';
import { Attribute, AttributeType, PropertyAttribute, RealProperty } from '@eemo/api-client';

@Injectable({ providedIn: 'root' })
export class DictionaryHelper {
  constructor() {}

  getAttrNameDisplay(attr: Attribute) {
    if (attr) {
      return attr.display.name;
    }
    return 'Attribut inconnu';
  }

  getAttrNameDisplayWithUnit(attr: Attribute) {
    let ret = this.getAttrNameDisplay(attr);
    if (attr && attr.unit) {
      ret += ' (' + attr.unit + ')';
    }
    return ret;
  }

  getAttrValueDisplay(attr: Attribute, value: string): string {
    let ret = value;
    if (attr.type === AttributeType.ENUM) {
      attr.availableValues.forEach((element) => {
        if (element.code === value) {
          ret = element.display.name;
        }
      });
    } else if (attr.type === AttributeType.BOOLEAN) {
      ret = value === 'true' ? 'Oui' : 'Non';
    } else if (attr.type === AttributeType.DECIMAL) {
      ret = value ? value.replace('.', ',') : '';
    }
    ret = attr.unit ? ret + ' ' + attr.unit : ret;
    return ret;
  }

  isAttrAvailableForProperty(attr: Attribute, prop: RealProperty) {
    return (
      !attr.allowedPropertyTypes ||
      attr.allowedPropertyTypes.length === 0 ||
      attr.allowedPropertyTypes.includes(prop.type)
    );
  }

  isAttrUpdateSinceCertif(attr: Attribute, value: PropertyAttribute): boolean {
    return attr.inCertification && value.certificationValue && value.certificationValue !== value.value;
  }

  getAttributeTypes(): string[] {
    return Object.keys(AttributeType);
  }

  getAttributeTypeName(type: AttributeType) {
    switch (type) {
      case AttributeType.BOOLEAN:
        return 'Oui/Non';
      case AttributeType.INTEGER:
        return 'Nombre entier';
      case AttributeType.DECIMAL:
        return 'Nombre décimal';
      case AttributeType.STRING:
        return 'Texte';
      case AttributeType.ENUM:
        return 'Liste de choix';
      default:
        return 'Type inconnu';
    }
  }
}
